// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__8KJSt","loader":"Loader_loader__2XW5F","loader_animation":"Loader_loader_animation__3dbS0"};